module.exports = __webpack_public_path__ + "assets/img/22_1309_big.06f42e3e.jpg";